var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"music-mute-btn thinly-shadowed",class:{ tutorial: _vm.showTutorial },on:{"click":_vm.controlMusic}},[(!_vm.playing)?_c('img',{staticClass:"mic-img",attrs:{"src":require("@/assets/img/utils/no-music.svg")}}):_c('img',{staticClass:"mic-img",attrs:{"src":require("@/assets/img/utils/music.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }